const api_url = require("../config.js").api_url;
const url = api_url + "/email/contact";

import axios from "axios";
class ContactService {
	async send_email(params) {
		try {
			const response = await axios.post(url, params);
			if (response.status === 200) {
				return true;
			} else {
				throw new Error();
			}
		} catch (error) {
			throw new Error("Error sending contact email");
		}
	}
}
export default new ContactService();
